import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../app/auth.service';
import { Configuration } from '../conf/app.constants';
import { BaseLoginComponent } from './base-login.component';

@Component({
  selector: 'sso-login',
  templateUrl: 'sso-login.template.html'
})
/**
 * Componente que invoca al login SSO al cargar la pagina
 */
export class SsoLoginComponent extends BaseLoginComponent implements OnInit {

  constructor(authService: AuthService, private _configuration: Configuration) {
    super(authService);
  }

  /**
   * Se hace login invocando a la URL del servidor SSO.
   */
  ngOnInit(): void {
    document.location.href = this._configuration.URL_BASE + 'sso/login';
  }

}
